import React, { useEffect } from "react";
import { useState } from "react";
// import NoDataComponent from "../../CoreComponents/NoDataComponent";
import SectionNoDataComponent from "../../CoreComponents/SectionNoDataComponent";
import { protocol, url, token } from "../../Functionalities/Config";
import "./sections.css";
import axios from "axios";
import { showMessage } from "../../Functionalities/Functions";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import NoImage from "../../Assets/images/no-image.png";
import { confirmAlert } from "react-confirm-alert";

function OfferSection({
  data,
  image_type,
  remove,
  type,
  priority,
  refreshData,
}) {
  // void 0
  const [Active, setActive] = useState(data.is_active ? true : false);
  const [ActiveItems, setActiveItems] = useState();

  useEffect(() => {
    setActive(data.is_active);
    updateCharacters(data.offer);
  }, [data]);

  // const [openModal, setOpenModal] = useState(false)
  const image =
    "https://ei.marketwatch.com/Multimedia/2016/06/23/Photos/ZQ/MW-EP981_hardro_20160623093917_ZQ.jpg?uuid=e1f42ece-3947-11e6-95f6-0015c588dfa6";
  const banners = [image, image, image];
  var sq = data.image_type === "SQUARE_BANNER" ? true : false;
  // void 0

  const changeState = () => {
    var fdata = new FormData();
    fdata.append("keyword", "update_section_status");
    fdata.append("status", Active ? "false" : "true");
    fdata.append("section_id", data.id);

    // void 0

    var config = {
      method: "patch",
      url: url + "/items/sections/",
      headers: {
        Authorization: token,
      },
      data: fdata,
    };

    axios(config)
      .then((res) => {
        if (res.data.Status) {
          showMessage(
            "Status updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
          refreshData();
        } else {
          showMessage(
            "Status update failed",
            "danger",
            "Failed!",
            "top",
            "top-right",
            0,
          );
        }
      })
      .catch((err) => {
        showMessage(
          "Status update failed",
          "danger",
          "Failed!",
          "top",
          "top-right",
          0,
        );
      });
  };

  const [characters, updateCharacters] = useState([]);
  // void 0

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    updateCharacters(items);

    let rankArray = [];
    for (var i = 0; i < items.length; i++) {
      rankArray.push(items[i].id);
    }

    var fdata = new FormData();

    fdata.append("keyword", "update_offers");
    fdata.append("order_lst", JSON.stringify(rankArray));
    fdata.append("section_id", data.id);

    var config = {
      method: "patch",
      url: url + "/items/sections/",
      headers: {
        Authorization: token,
      },
      data: fdata,
    };

    axios(config)
      .then(function (response) {
        if (response.data.Status == true) {
          showMessage(
            "Position updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
        } else {
          showMessage(
            "Position updated failed",
            "danger",
            "Failed!",
            "top",
            "top-right",
            0,
          );
        }
      })
      .catch(function (error) {
        showMessage(
          "Position updated failed",
          "danger",
          "Failed!",
          "top",
          "top-right",
          0,
        );
      });
  }

  const grid = 8;

  const getItemStyle = (draggableStyle, isDragging) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 ${grid}px 0 0`,
    // marginRight: 15,
    color: "black",
    border: "1px solid",
    borderRadius: ".5rem",
    // change background cmolour if dragging
    background: "white",
    borderColor: isDragging ? "#FB310D" : "lightgray",

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    //   background: isDraggingOver ? "yellow" : "white",
    // padding: grid,
    //   width: 250,
    display: "flex",
    padding: grid,
    overflow: "auto",
  });

  const handleChangeActive = (status, itemId) => {
    var fdata = new FormData();
    fdata.append("keyword", "update_section_inner_data_status");
    fdata.append("type", "update_offers");
    fdata.append("update_list", JSON.stringify([itemId]));
    fdata.append("section_id", data.id);
    fdata.append("status", status);

    var config = {
      method: "patch",
      url: url + "/items/sections/",
      headers: {
        Authorization: token,
      },
      data: fdata,
    };

    axios(config)
      .then(function (response) {
        if (response.data.Status) {
          showMessage(
            "Status updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
          refreshData();
        } else {
          showMessage(
            "Status update failed",
            "danger",
            "Failed!",
            "top",
            "top-right",
            0,
          );
        }
      })
      .catch(function (error) {
        showMessage(
          "Status update failed",
          "danger",
          "Failed!",
          "top",
          "top-right",
          0,
        );
      });
  };

  const deleteOffer = (itemId) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className="custom-ui"
            style={{
              borderRadius: 8,
              border: "solid",
              padding: 70,
              borderWidth: 0.5,
            }}
          >
            <h1>Are you sure?</h1>
            <p>Press remove to remove this offer from the section</p>
            <button
              onClick={onClose}
              className="btn btn-primary"
              style={{ marginRight: 10 }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                var fdata = new FormData();
                fdata.append("keyword", "remove_offer");
                fdata.append("offer_list", JSON.stringify([itemId]));
                fdata.append("id", data.id);

                var config = {
                  method: "put",
                  url: url + "/items/sections/",
                  headers: {
                    Authorization: token,
                  },
                  data: fdata,
                };

                axios(config)
                  .then(function (response) {
                    if (response.data.Status) {
                      showMessage(
                        "Section updated",
                        "success",
                        "Success!",
                        "top",
                        "top-right",
                        0,
                      );
                      // refreshData()
                      window.location.reload();
                    } else {
                      showMessage(
                        "Section update failed",
                        "danger",
                        "Failed!",
                        "top",
                        "top-right",
                        0,
                      );
                    }
                  })
                  .catch(function (error) {
                    showMessage(
                      "Section update failed",
                      "danger",
                      "Failed!",
                      "top",
                      "top-right",
                      0,
                    );
                  });
              }}
              className="btn btn-primary"
            >
              Remove
            </button>
          </div>
        );
      },
    });
  };

  return (
    <div className="card m-0">
      <div className="card-header p-0 mb-2">
        <h5 className="card-title ">
          <img
            src={
              data.icon
                ? data.icon.image
                  ? data.icon.image
                  : NoImage
                : NoImage
            }
            alt=""
            style={{ width: "2rem", height: "2rem", objectFit: "cover" }}
          />
          {priority} {data.name}{" "}
          {window.location.pathname
            .toLowerCase()
            .includes("mobilelandingpage") && (
            <span>
              <i
                class="fa fa-eye ml-1"
                style={{ cursor: "pointer", color: "#EF4832" }}
                onClick={() => (window.location.href = "/section/" + data.id)}
              />
            </span>
          )}
        </h5>
        <button
          className={
            Active
              ? "btn btn-xs btn-outline-primary "
              : "btn btn-xs btn-primary"
          }
          onClick={() => changeState()}
        >
          {Active ? "Disable" : "Activate"}
        </button>
      </div>
      <div
        className="list-group-item list-group-item-action flex-column align-items-start p-0"
        style={{ overflowX: "scroll" }}
      >
        {true && (
          <div className="d-flex align-items-center ">
            {data.offer.length > 0 ? (
              <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="droppable" direction="horizontal">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                      {...provided.droppableProps}
                    >
                      {characters.map((item, index) => {
                        // void 0
                        return (
                          <Draggable
                            key={item.id}
                            draggableId={item.id.toString()}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div>
                                <div
                                  ref={provided.innerRef}
                                  {...provided.dragHandleProps}
                                  {...provided.draggableProps}
                                  style={getItemStyle(
                                    provided.draggableProps.style,
                                    snapshot.isDragging,
                                  )}
                                >
                                  <div className="mx-2">
                                    <div style={{ position: "relative" }}>
                                      <img
                                        name="one"
                                        src={
                                          sq
                                            ? item.image
                                              ? url + item.image.image
                                              : "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/600px-No_image_available.svg.png"
                                            : item.second_image
                                              ? url + item.second_image.image
                                              : "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/600px-No_image_available.svg.png"
                                        }
                                        alt=""
                                        style={{
                                          width: sq ? "10rem" : "18rem",
                                          height: sq ? "10rem" : "10rem",
                                          objectFit: "cover",
                                          borderRadius: ".5rem",
                                        }}
                                      />
                                      <div className="round-btn-wrapper">
                                        <label class="switch">
                                          <input
                                            checked={item.is_active}
                                            onChange={(e) =>
                                              handleChangeActive(
                                                e.target.checked,
                                                item.id,
                                              )
                                            }
                                            type="checkbox"
                                            id="togBtn"
                                          />
                                          <div class="slider round">
                                            <span class="on">ON</span>
                                            <span class="off">OFF</span>
                                          </div>
                                        </label>

                                        <button
                                          className="round-button"
                                          title={"remove"}
                                          onClick={() => deleteOffer(item.id)}
                                        >
                                          <i className="fa fa-trash text-primary"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            ) : (
              // ))
              <SectionNoDataComponent data="Items found" />
            )}

            {false && (
              <div className="d-flex align-items-center ">
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="droppable" direction="horizontal">
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                        {...provided.droppableProps}
                      >
                        {characters.map((item, index) => {
                          return (
                            <Draggable
                              key={item.id}
                              draggableId={item.id.toString()}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div>
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.dragHandleProps}
                                    {...provided.draggableProps}
                                    style={getItemStyle(
                                      provided.draggableProps.style,
                                      snapshot.isDragging,
                                    )}
                                  >
                                    <div className="mx-2">
                                      <div style={{ position: "relative" }}>
                                        <img
                                          name="two"
                                          src={
                                            sq
                                              ? item.image?.image.replace(
                                                  "http://",
                                                  protocol,
                                                )
                                              : item.second_image?.image.replace(
                                                  "http://",
                                                  protocol,
                                                )
                                          }
                                          alt=""
                                          style={{
                                            width: sq ? "10rem" : "18rem",
                                            height: sq ? "10rem" : "10rem",
                                            objectFit: "cover",
                                            borderRadius: ".5rem",
                                          }}
                                        />
                                        <div className="round-btn-wrapper">
                                          <label class="switch">
                                            <input
                                              checked={item.is_active}
                                              onChange={(e) =>
                                                handleChangeActive(
                                                  e.target.checked,
                                                  item.id,
                                                )
                                              }
                                              type="checkbox"
                                              id="togBtn"
                                            />
                                            <div class="slider round">
                                              <span class="on">ON</span>
                                              <span class="off">OFF</span>
                                            </div>
                                          </label>

                                          <button
                                            className="round-button"
                                            title={"remove"}
                                            onClick={() => deleteOffer(item.id)}
                                          >
                                            <i className="fa fa-trash text-primary"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default OfferSection;
